import { JsonDecoder } from 'ts.data.json';
import { OrderMarkNigoResponse } from './model';

export const orderMarkNigoResponseDecoder = JsonDecoder.object<OrderMarkNigoResponse>(
    {
        id: JsonDecoder.string,
        status: JsonDecoder.string
    },
    'OrderMarkNigoResponse'
);
